import styled from "styled-components";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext";
import { useState } from "react";
import useApi from "../../../hooks/useApi";
const Titulo = styled.h2`
    margin: 5px auto;
    text-align: center;
    color: #000;
`

const ModalAddTreinamento = ({ modo, item = null, onSuccess }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [ treinamento, setTreinamento ] = useState( item ? item.treinamento : "" );
    const [ loading, setLoading ] = useState(false);

    const handleChange = ( e ) => {

        let value = e.target.value.toUpperCase();
        setTreinamento(value);

    }

    const handleSubmit = async ( e ) => {

        e.preventDefault();
        setLoading( true );

        try{

            const formData = new FormData();
            formData.append("treinamento", treinamento);

            if( modo === "edit" && item ){

                formData.append("identifier", item.identifier);

            }

            const url = "/Painel/API/Treinamentos/CreateTreinamento/";
            const { data } = await api.post( url, formData, { withCredentials: true } );

            console.log(data);
            if( onSuccess ) onSuccess();

        }catch( error ){

            console.error(error);
            alert("Erro ao salvar treinamento. Tente novamente mais tarde.");

        }finally{

            setLoading( false );

        }

    }

    return(
        <Overlay state={ true } >
            <Modal size="md" header={ true } close={ closeModal } >
                <Titulo>
                    { modo === "edit" ? "EDITAR TREINAMENTO" : "ADICIONAR TREINAMENTO" }
                </Titulo>
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="NOME DO TREINAMENTO"
                        type="text"
                        changeFunc={ ( e ) => handleChange( e ) }
                        valor={ treinamento }
                        required
                        disabled={ loading }
                    />
                    <FormComp
                        type="submit"
                        valor={ loading ? "SALVANDO..." : "SALVAR" }
                        disabled={ loading }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalAddTreinamento;